// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4f31c52a","977":"9067e2e5"}[chunkId] + ".chunk.js";
};